import CityPageTemplate from "../city-template/CityPageTemplate";
import { durangoConfig } from "./data";

export default function DurangoPage() {
  return <CityPageTemplate config={durangoConfig} />;
}